import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
  useToastMessage,
} from '@equip.health/ui';
import { useDeleteQolGoalMutation } from '~/store/services/carePlan';
import { useEffect } from 'react';

type Props = {
  treatmentEpisodeId: string;
  goalId: string;
  onClose: () => void;
};
export const RemoveQolGoalConfirmationModal = ({
  goalId,
  treatmentEpisodeId,
  onClose,
}: Props) => {
  const [
    deleteQolGoal,
    { isLoading: isDeleteQolGoalLoading, isError: isDeleteQolGoalError },
  ] = useDeleteQolGoalMutation();
  const { createToast } = useToastMessage();
  useEffect(() => {
    if (isDeleteQolGoalError) {
      createToast({
        icon: FAIconName.exclamationTriangleRegular,
        id: 'remove-goal-confirmation-error_toast',
        text: "We're sorry, we were unable to remove this goal. Please try again later",
        variant: 'critical',
      });
      onClose();
    }
  }, [isDeleteQolGoalError]);
  return (
    <ModalV2 isOpen onClose={onClose} title="Remove goal">
      <Text>
        Are you sure you want to remove this goal from the care plan? Please
        note, all related problems and interventions will also be removed.
      </Text>
      <ChakraFlex
        alignItems="center"
        justifyContent="space-between"
        marginTop="24px"
        width="100%"
      >
        <FireflyButton
          id="remove-goal-confirmation-modal-cancel-button"
          isLoading={isDeleteQolGoalLoading}
          leftIcon={FAIconName.timesRegular}
          onClick={onClose}
          variant="secondary"
        >
          Cancel
        </FireflyButton>
        <FireflyButton
          id="remove-goal-confirmation-modal-remove-button"
          isLoading={isDeleteQolGoalLoading}
          leftIcon={FAIconName.trashRegular}
          onClick={() => {
            deleteQolGoal({
              goalId,
              treatmentEpisodeId,
            }).then(() => {
              onClose();
            });
          }}
          variant="accent.critical"
        >
          Remove goal
        </FireflyButton>
      </ChakraFlex>
    </ModalV2>
  );
};
